import { render, staticRenderFns } from "./UserStatusBadge.vue?vue&type=template&id=5765f9e0&"
import script from "./UserStatusBadge.vue?vue&type=script&lang=js&"
export * from "./UserStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports